// Import polyfills first
import './polyfills';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { registerSW } from './registerSW';

// Register service worker
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  registerSW();
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 